exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-eoi-submit[data-v-52be193c] {\n  color: #00007d;\n  border-radius: 30px;\n  background-color: #6dfe6d !important;\n}", ""]);

// exports
